export default "__VITE_ASSET__BE0tjW4T__"